import React, { useState } from "react";
import DateTimePicker from 'react-datetime-picker';

import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar.js";


import { Button } from "@mui/material";

export default function TeacherRequestHandle() {
  const [startDate, setStartDate] = useState(new Date());
  const [value, onChange] = useState(new Date());

  return (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-blueGray-100">
        <Navbar />
        {/* Header */}
        <div className="relative bg-pink-600 md:pt-12 pb-10">
          <div className="px-4 md:px-10 mx-auto w-full ml-2 d-flex align-items-center justify-content-center flex-column">
           <div style={{height:38}}>

           </div>
            <div className="d-flex align-items-center flex-column pb-9">
              <h1 className="text-white font-semibold text-3xl	 text-center">
               List of Received Request
              </h1>
            </div>
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <th scope="col">Account</th>
              <th scope="col"> Date</th>
              <th scope="col">Amount</th>
              <th scope="col">Period</th>
              <th scope="col">Date & Time</th>
              <th scope="col">Submit</th>

            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-label="Sr#">Visa - 3412</td>
              <td data-label="Date">04/01/2016</td>
              <td data-label="Amount">$1,190</td>
              <td data-label="Period">03/01/2016 - 03/31/2016</td>

              <td data-label="Date & Time">
              <DateTimePicker onChange={onChange} value={value} />

              </td>


              <td>
<button className="btn btn-danger">
  Submit
</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
